import React, { useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { BsGlobe } from "react-icons/bs";

const LanguageSelector = () => {
  const { currentLanguage, supportedLanguages, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  // Close dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (isOpen && !event.target.closest('.language-selector')) {
      setIsOpen(false);
    }
  };

  // Add event listener for clicking outside
  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const handleLanguageChange = (code) => {
    console.log('Language selected:', code);
    changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-selector relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
      >
        <BsGlobe className="text-gray-700" />
        <span className="text-sm font-medium text-gray-700">
          {supportedLanguages[currentLanguage]}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg py-2 z-50 max-h-60 overflow-y-auto">
          {Object.entries(supportedLanguages).map(([code, name]) => (
            <button
              key={code}
              onClick={() => handleLanguageChange(code)}
              className={`block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors ${
                currentLanguage === code ? 'bg-blue-50 font-semibold' : ''
              }`}
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;